<template>
  <div class="card-alert">
    <i class="icon-nave-card-alert" />
    <span>{{ title }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NaveCardAlert",

  props: {
    title: { type: String, required: true },
  },
});
</script>

<style lang="scss">
.card-alert {
  background: var(--insights-color-19);
  padding: toRem(20px);
  font-size: toRem(16px);
  line-height: toRem(21px);
  color: var(--insights-color-17);
  border-radius: 6px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;

  i {
    background: var(--insights-color-5);
    margin-right: 10px;
    font-size: toRem(36px);
  }
}
</style>
